
import { BModal }          from 'bootstrap-vue';
import { Component, Prop } from '$/lib/vueExt';

/**
 * Overwrite BModal to add support for bigger modals.
 */
@Component
export default class Modal extends BModal {

	/**
	 * Determines how the modal will stretch to the full height/width of the viewport.
	 * 'vertical'   will stretch the modal to the full height of the viewport.
	 * 'horizontal' will stretch the modal to the full width of the viewport.
	 * 'both'       will stretch the modal to the full height and width of the viewport.
	 * 'none'       will not stretch the modal.
	 * 'size'       will stretch the width of the modal to the max of the size prop.
	 */
	@Prop({ default : 'none' })
	readonly stretch: 'none' | 'vertical' | 'horizontal' | 'both' | 'size';

	get dialogClasses() {
		return [
			...(BModal as any).options.computed.dialogClasses.call(this),
			{
				'size'               : this.size,
				'stretch-horizontal' : this.stretch === 'horizontal' || this.stretch === 'both',
				'stretch-vertical'   : this.stretch === 'vertical'   || this.stretch === 'both',
				'stretch-size'       : this.stretch === 'size',
			},
		];
	}

}
